import React, { useEffect, useState } from "react";
import BlastStyle from "./blast.module.css";
import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Upload,
  Col,
  Row,
  Select,
  Table,
  Modal,
} from "antd";
import http from "../../../utils/http";
import BlastName from "./json/blast_names";
import { useNavigate } from "react-router-dom";
const { TextArea } = Input;
const { Option } = Select;

function Blast() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const [nucleotideDisabled, setNucleotideDisabled] = useState(false);
  const [proteinDisabled, setProteinDisabled] = useState(false);
  const [formObject, setFormObject] = useState("");
  const [BlastDetail, setBlastDetail] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);
  const [TableData, setTableData] = useState([]);
  const [DetailTable, setDetailTable] = useState([]);

  const onFinish = (values) => {
    console.log(
      values.nucleotide_database
        ? values.nucleotide_database
        : values.protein_database
    );

    setFormObject(
      values.nucleotide_database
        ? values.nucleotide_database
        : values.protein_database
    );
    setIsSubmit(true);

    const newFormData = new FormData();
    const TempleObject = {
      SN: values.SN === undefined ? values.gene_id_text : values.SN.file,
      seq_type: values.nucleotide_database ? 1 : 2,
      comp_species: values.nucleotide_database
        ? values.nucleotide_database
        : values.protein_database,
      comp_param: values.advanced_parameters,
    };
    Object.keys(TempleObject).forEach((key) => {
      newFormData.append(key, TempleObject[key]);
    });
    http
      .post("/api/tools/blast/", newFormData)
      .then((res) => {
        setIsSubmit(false);
        setBlastDetail(res);
        Object.keys(res).map((key1) => {
          setTableData(res[key1].m7);
        });
      })
      .catch((err) => {
        setIsSubmit(false);
      });
    // navigate('/Sugarcane/blastdetail/')
  };

  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };

  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);

  const handleNucleotideChange = (value) => {
    setNucleotideDisabled(value.length > 0);
    setProteinDisabled(false);
  };

  const handleProteinChange = (value) => {
    setProteinDisabled(value.length > 0);
    setNucleotideDisabled(false);
  };

  const [DetailIs, setDetailIs] = useState(false);
  const showModalDetail = () => {
    setDetailIs(true);
  };
  const handleOkDetail = () => {
    setDetailIs(false);
  };
  const handleCancelDetail = () => {
    setDetailIs(false);
  };
    const [IsSpShow, setIsSpShow] = useState(false);
    const [SpContent,setSpContent]=useState("")
    const [IsHeight,setISHeight]=useState("")
    const showModalSp = () => {
      setIsSpShow(true);
    };
    const handleOkSp = () => {
      setIsSpShow(false);
    };
    const handleCancelSp = () => {
      setIsSpShow(false);
    };
  const colums = [
    {
      key: "1",
      title: "query",
      dataIndex: "query",
      align: "center",
    },
    {
      key: "2",
      title: "alignment length",
      dataIndex: "alignment length",
      align: "center",
    },
    {
      key: "3",
      title: "evalue",
      dataIndex: "evalue",
      align: "center",
    },
    {
      key: "4",
      title: "q. start",
      dataIndex: "q. start",
      align: "center",
    },
    {
      key: "5",
      title: "q. end",
      dataIndex: "q. end",
      align: "center",
    },
    {
      key: "6",
      title: "s. start",
      dataIndex: "s. start",
      align: "center",
    },
    {
      key: "6",
      title: "s. end",
      dataIndex: "s. end",
      align: "center",
    },
    {
      // acc.ver
      key: "7",
      title: "acc.ver",
      dataIndex: "acc.ver",
      align: "center",
      render: (index, item) => {
        return (
          <span style={{ cursor: "pointer" }} onClick={()=>{
            http
            .get(
              `/api/genome/geneIndex/?species=${formObject}&gene_id=${index}`
            )
            .then((res) => {
              console.log(res);
              setDetailTable(res)
            showModalDetail()

            })
            .catch((err) => {
              console.log(err);
            });
          }}>
            {index}
          </span>
        );
      },
    },
    {
      key: "8",
      title: "score",

      dataIndex: "score",
      align: "center",
    },
    {
      key: "9",
      title: "subject acc.ver % identity",
      dataIndex: "subject acc.ver % identity",
      align: "center",
    },
  ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [BiologicalVal, setBiologicalVal] = useState("");
  const [CellularVal, setCellularVal] = useState("");
  const [MolecularVal, setMolecularVal] = useState("");
  const [GoContnetOne, setGoContentOne] = useState("");
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [IsKEGGShow, setIsKEGGShow] = useState(false);
  const [KEGGContent_index, setKEGGContent_index] = useState("");
  const [KEGGContent_name, setKEGGContent_name] = useState("");
  const [KEGGContent_link, setKEGGContent_link] = useState("");
  const [KEGGContent_pathway, setKEGGContent_pathway] = useState("");
  const showModalKEGG = () => {
    setIsKEGGShow(true);
  };
  const handleOkKEGG = () => {
    setIsKEGGShow(false);
  };
  const handleCancelKEGG = () => {
    setIsKEGGShow(false);
  };
  const columsDetail = [
    {
      key: "1",
      title: "Chr",
      dataIndex: "gene_name",
      align: "center",
    },
    {
      key: "2",
      title: "Gene ID",
      dataIndex: "gene_id",
      align: "center",
    },
    {
      key: "3",
      title: "mRNA ID",
      dataIndex: "mrna_id",
      align: "center",
    },
    {
      title: <p style={{ fontWeight: "bold" }}>Position</p>,
      dataIndex: "position",
      key: "position",
      // width: "20%",
      align: "center",
      render: (index, item) => {
        return (
          <p>
            <span>{item.chr}:</span>
            <span>{item.start}-</span>
            <span>{item.end}</span>
          </p>
        );
      },
    },
    {
      // width: "35%",
      title: <p style={{ fontWeight: "bold" }}>KEGG</p>,
      dataIndex: "gene_KO_ID",
      key: "gene_KO_ID",
      align: "center",
      render: (index, item) => {
        return (
          <p
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "50px",
              overflow: "auto",
              cursor: "pointer"
            }}
            onClick={()=>{
              showModalKEGG()
              setKEGGContent_index(index)
              setKEGGContent_name(item.gene_KO_name)
              setKEGGContent_link(item.gene_KO_link)
              setKEGGContent_pathway(item.gene_Pathway)
            }}
          >
            <span>{index}</span>
            <span>{item.gene_KO_name}</span>
            <span>{item.gene_KO_link}</span>
            <span>{item.gene_Pathway}</span>
          </p>
        );
      },
    },
  
        {
          title: <p style={{ fontWeight: "bold" }}>Swissprot</p>,
          dataIndex: "sp",
          key: "sp",
          width: "300px",
          align: "center",
          render: (index, item) => {
            return <p style={{
              height:"50px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("sp")

            }}
            >{index}</p>;
          },
        },
        {
          title: <p style={{ fontWeight: "bold" }}>GO</p>,
          dataIndex: "go",
          key: "go",
          width: "300px",
          align: "center",
          render: (index, items) => {
            return (
              <p
                className={BlastStyle.go_content}
                onClick={() => {
                  setBiologicalVal(items.gene_Biological_Process);
                  setCellularVal(items.gene_Cellular_Component);
                  setMolecularVal(items.gene_Molecular_Function);
                  // setGoContentOne(items.gene_go);
                  showModal();
                }}
              >
                {/* <span>{items.gene_go}</span> */}
                <span>{items.gene_Biological_Process}</span>
                <span>{items.gene_Cellular_Component}</span>
                <span>{items.gene_Molecular_Function}</span>
              </p>
            );
          },
        },
    {
      key:"transcripts",
      dataIndex:"transcripts",
      align:"center",
      title:"mRNA Sequences",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("mRNA")
            }}
        >{index}</p>;
      },
    }, {
      key:"gene",
      dataIndex:"gene",
      align:"center",
      title:"DNA Sequences",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("dna")
            }}
        >{index}</p>;
      },
    },{
      key:"cds",
      dataIndex:"cds",
      align:"center",
      title:"CDS",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("CDS")
            }}
        >{index}</p>;
      },
    },{
      key:"pep",
      dataIndex:"pep",
      align:"center",
      title:"PEP",
      render: (index, item) => {
        return <p style={{
          width:"200px",
              height:"80px",
              overflow:"auto",
              cursor:"pointer"
            }}
            onClick={()=>{
              showModalSp(true)
              setSpContent(index)
              setISHeight("pep")
            }}
        >{index}</p>;
      },
    }
  ];
  return (
    <div className={BlastStyle.Blast_app}>
      <div className={BlastStyle.Blast_Header}>
        <p>Blast</p>
      </div>
      <Modal
        open={DetailIs}
        onOk={handleOkDetail}
        onCancel={handleCancelDetail}
        width={1300}
      >
         <Table
                 style={{ width: "95%", margin: "auto" }}
                 columns={columsDetail}
                 dataSource={DetailTable}
                 bordered
                 scroll={{
                  x: "scroll",
                 }}
               />
      </Modal>
      <Modal
        open={IsKEGGShow}
        onOk={handleOkKEGG}
        onCancel={handleCancelKEGG}
        style={{ textAlign: "center" }}
      >
        <p>{KEGGContent_index}</p>
        <p>{KEGGContent_name}</p>
        <p>{KEGGContent_link}</p>
        <p>{KEGGContent_pathway}</p>
      </Modal>
      <Modal open={IsSpShow} onOk={handleOkSp} onCancel={handleCancelSp}>
            <p style={{padding:"10px",overflow:"auto",height:IsHeight=='sp'?"auto":"500px",margin:"20px"}}>{SpContent}</p>
                  </Modal>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <p>{GoContnetOne}</p>
        <p>
          <span style={{ fontWeight: "bold" }}>Biologoica process:</span>
          {BiologicalVal}
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Cellular component:</span>
          {CellularVal}
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Molecular function:</span>
          {MolecularVal}
        </p>
      </Modal>
      <div className={BlastStyle.Blast_Form}>
        <Form
          form={form}
          onFinish={onFinish}
          style={{ width: "90%", margin: "auto" }}
          initialValues={{
            advanced_parameters: "-num_alignments 100 -evalue 1e-05",
          }}
        >
          <Form.Item name="gene_id_text">
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Form.Item
            name="SN"
            style={{
              width: "60%",
            }}
          >
            <Upload
              beforeUpload={contentUpload}
              name="SN"
              action="/upload.do"
              onRemove={() => {
                setFileContent("");
              }}
            >
              <Button
                style={{
                  border: "none",
                  padding: "0",
                  margin: "0",
                  background: "transparent",
                }}
                icon={<UploadOutlined />}
              >
                Click to upload
              </Button>
            </Upload>
          </Form.Item>
          <Row>
            <Col span={11}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>
                    Nucleotide database
                  </span>
                }
                name="nucleotide_database"
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="Select nucleotide database"
                  disabled={proteinDisabled}
                  onChange={handleNucleotideChange}
                >
                  {BlastName.map((v) => {
                    return <Option value={v}>{v}</Option>;
                  })}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  style={{
                    color: "#67C23A",
                    border: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    form.setFieldsValue({
                      gene_id_text: `>OF00226
ATGAAACATAACAAAGAGAAGGTTGTTAATGCAAGAGCCATGAAACCGCTGGTGGACTTGATTTCAGAACAGGGGAGAGGTTTGACGGAGAAGGCGATGGT
GGTTTTGAGCAGCTTAGCTACAATTCCAGAGGCCAGAATTGCCATAGTCGAAGAGGGAGGGGTTACAGTTTTGGTTGAAGCGATCGAAGTTAGGTCAGTGA
AAGGGAAAGAGTTCGTGGTACTGAAGCTTCTGCAACTATGCGCGGATAGTGTACGGAACAGAGGATTGTTGGTGAGAGAAGTTGGGATCTCGCCACTTGTT
GCACTCTCTCAGACGGGCACAGCTTGA
>OF00227
ATGGGAAAGCCGAAGAAGGTGGAGTTGGCATCAATCGACAAAATAGGAGCCATATTTATATCCGAAAGCTGCAACGGAGATGGTGGGGCTGAAATCACTTT
GACGCTTAGAGGACTTGAGATGGATGCCTTTGCTTTTGTATTTGTTAATGGTCTTAAGGGAAAAGGCTATGTGTTGTATTGA
>OF00228
ATGGACCTCTCATTTCCTTCTTTACCGTCCCTTCCTATCTCGACAAAAGCCATAAACAGAAAGAACTCTGTGCTACCAACGGGTAATTGGTCGTCAAAACAAGCAACACAGAGTCGATCATTCCGGCCCGCAAGCGTAGCAACCGATGCGGCAGTGGAATTTGAGCTGGAAAACAAAAAGCACAACCTGCTGAGAGCCATACAGGATACGCAACGTGGACTTGTCAATACCGCTGATCAACGCTCTTCCATTGAGGAGGCCCTGGTGAGCGTGGAGGGCTACGACGCTGGTTCGGAAATCGACCTGGTGAAGTTAGACGGAGCGTGGCGATTGCAGTACACTTCCGCTCCTGATGTCCTCATCCTTCTAGAGTCCGCTGCAAAGCTTCCCTTCTTTCAGGTTGGGCAAATCTTCCAAAAATTTGAATGTCACAAGCAGTCTGATGGAGGCATTGTCCGCAATGTTGTGCGTTGGAGCATTTCAAGTTTATTAGAGGAGCAAGAAGGTGCAACCCTAATTGTTTCTGCAAAATTTTCAGTTGTTTCAAGCGTAACATTTACCTTCAATTTGAAGAGGTAG
`,
                      nucleotide_database: "NNU",
                      protein_database: "",
                      advanced_parameters: "-num_alignments 100 -evalue 1e-05",
                    });
                    setNucleotideDisabled(true);
                    setProteinDisabled(false);
                  }}
                >
                  example
                </Button>
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <Form.Item
                label={
                  <span style={{ fontWeight: "bold" }}>Protein database</span>
                }
                name="protein_database"
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="Select protein database"
                  disabled={nucleotideDisabled}
                  onChange={handleProteinChange}
                >
                  {BlastName.map((v) => {
                    return <Option value={v}>{v}</Option>;
                  })}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  style={{
                    color: "#67C23A",
                    border: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    form.setFieldsValue({
                      gene_id_text: `>chr3.g13039
MEDRVASGGGYRSLNPWSKGQGGFRAAMFIFVFTALENIGFVANMTGFYL
YFYLVMHFDISGSANALTSFMGSTYLLSLVGGFIADTYLSRLSTCLIFGL
LEIVAMMILTVQAHYQKFQPEPCDKSPCVNGGKALMFYSSLCLLALGAGG
VKGALPALGGDQFNQKDPKEGKALASFFNWLLLSSTLGATIGVTVIQWVN
TNKGWDLGFFICTILTFAGYIVLSLGKPFYHKRAPGDSPLVRIIQVIVVA
IRNRSSSLPVNPGQLYEISDKNIASDEETISHTNQFRFLDKAAILRQGSN
PEPWRVCTVTQVEELKILMRMLPIIASTILLNTCLAQLQTFSVQQGSVMN
RQLGKFQVPAPSIPVIPLVFISILIPIYQFIFVPFARRITHRPSGITHLQ
RVGFGLVLSIISMAIAGVVEVKRRDQVIKDPTKPISLFWLSFQYGVFGFA
DMFTLVGLLEFYYKEAPSGMRSLSTSFAWLSQSIGYFLSSVFVELINSIT
KRFTPSKQGWLEGMDLNKNNLNLFYWFLAVLSCLNFANYCFWASWYKCKS
DSPLSLLLLSKVPSGSSPVPFHRKEISMQNVVGTIENGYGISTPGLVEDG
AEKQEEK
>chr3.g13040
MASEGGDPGTFYTRMRKSLDQRIGTEQTLHPRPRSGFDLTMWLMTLGGTS
FDQQLSLVLLLRRATVMEPMRSPSLLATRLLVEGEDGEEAEVGEDGEEAE
VGEDDEEAEVVESTNDSRDRIQTTTVVAMVAEKQGVERLQSDSL
`,
                      protein_database: "NNU",
                      nucleotide_database: "",
                      advanced_parameters: "-num_alignments 100 -evalue 1e-05",
                    });
                    setProteinDisabled(true);
                    setNucleotideDisabled(false);
                  }}
                >
                  example
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label={
              <span style={{ fontWeight: "bold" }}>Advanced parameters</span>
            }
            name="advanced_parameters"
          >
            <Input placeholder="The default value: -numallgnments 100 -evalue 1e-05" />
          </Form.Item>
          <Form.Item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              style={{
                margin: "0 10px",
                background: "#67C23A",
                border: "none",
                color: "white",
              }}
              htmlType="submit"
              loading={IsSubmit}
            >
              Submit
            </Button>
            <Button
              style={{
                border: "1px solid #6C5E6E",
                color: "#6C5E6E",
              }}
              onClick={() => {
                form.resetFields();
                setProteinDisabled(false);
                setNucleotideDisabled(false);
                setBlastDetail({});
              }}
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
      {Object.keys(BlastDetail).length !== 0 ? (
        <>
          <Table
            bordered
            columns={colums}
            dataSource={TableData}
            style={{ width: "95%", margin: "auto" }}
          />
          <div className={BlastStyle.Blast_content}>
            {Object.keys(BlastDetail).length == 0
              ? ""
              : Object.keys(BlastDetail).map((key) => {
                  console.log(BlastDetail[key].m7);
                })}
          </div>
        </>
      ) : (
        ""
      )}
      <div style={{ height: "20px" }}></div>
    </div>
  );
}

export default Blast;
